import { ApiPlugin } from '@/plugins';

export default class HomeService {
  static async fetchHomeCards(region) {
    const nid = window.drupalSettings?.webform?.dialog?.entity_id ?? '4960550';
    const regionId = region ? `&region=${region}` : '';
    const response = await ApiPlugin.get(`/api/home/content/get?nid=${nid}${regionId}`);
    return response.data;
  }

  static getPlaceholders() {
    const drupalSettingsPlaceholders = window.drupalSettings?.search?.placeholders;
    const defaultPlaceholders = {
      text_desktop: 'Votre recherche',
      text_mobile: 'Votre recherche',
      text_where: 'Précisez votre ville',
    };
    return { ...defaultPlaceholders, ...drupalSettingsPlaceholders };
  }

  static async fetchOptionsRegions() {
    const response = await ApiPlugin.get('/api/regions');
    return response.data;
  }
}
